import React, {useState} from 'react';
import {Image as ImageIcon} from 'lucide-react';
import {AppText, AppBodyText} from '../../../Presentation/components/ui/Typography';

interface ProductImagesGalleryProps {
  images: string[] | undefined | null;
  productName: string;
  variant?: 'page' | 'modal';
  onOpenModal?: (selectedIndex: number) => void;
}

const PLACEHOLDER = '/assets/images/store_placeholder.png';

export const ProductImagesGallery: React.FC<ProductImagesGalleryProps> = (props) => {
  const {images, productName, variant = 'page', onOpenModal} = props;
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

  if (!images || images.length === 0) {
    const heightClass = variant === 'page' ? 'h-64' : 'h-48';
    return (
      <div className={`w-full ${heightClass} bg-gray-100 rounded-lg flex items-center justify-center`}>
        <div className="text-center">
          <ImageIcon size={variant === 'page' ? 48 : 32} className="mx-auto text-gray-400 mb-2" />
          <AppBodyText className="text-gray-500">لا توجد صور للمنتج</AppBodyText>
        </div>
      </div>
    );
  }

  const mainHeight = variant === 'page' ? 'h-64' : 'h-48';
  const thumbSize = variant === 'page' ? 'w-16 h-16' : 'w-12 h-12';

  return (
    <div className="space-y-3">
      {/* Main Image */}
      <div className={`relative ${mainHeight} w-full bg-gray-50 rounded-lg flex items-center justify-center`}
      >
        <img
          src={images[selectedImageIndex]}
          alt={productName}
          className="max-h-full max-w-full object-contain rounded-md cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => onOpenModal?.(selectedImageIndex)}
          onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
        />
        {images.length > 1 && (
          <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-sm">
            {selectedImageIndex + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Thumbnail Images */}
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${productName} ${index + 1}`}
              className={`${thumbSize} object-contain bg-white rounded cursor-pointer p-0.5 shadow-sm ${
                index === selectedImageIndex ? 'border-2 border-brand-500' : 'border border-gray-300'
              }`}
              onClick={() => setSelectedImageIndex(index)}
              onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductImagesGallery;


